export class PowermailValidations {
  constructor() {
    $(document).ready(function () {
      window.Parsley.addValidator('custom100', {
        validateString: function (_value, requirement, parsleyInstance) {
          let file = parsleyInstance.$element[0].files[0];
          let requirements = requirement.split(',');
          let [width, height] = requirements[0].split('*');
          let image = new Image();
          let deferred = $.Deferred();

          image.src = window.URL.createObjectURL(file);
          image.onload = function () {
            if (image.width >= width && image.height >= height) {
              deferred.resolve();
            } else {
              deferred.reject();
            }
          };

          return deferred.promise();
        },
        requirementType: 'string',
        messages: {
          en: 'Image dimensions have to be at least  %s px',
          de: 'Bildgröße soll mindestens %s px sein'
        }
      });
    });
  }
}
